import select from "./select.json";

export default { select };
